"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationButton = function PaginationButton(_ref) {
  var direction = _ref.direction,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var label = direction === "back" ? "Previous page" : "Next page";
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "p-pagination__item"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)({
      "p-pagination__link--previous": direction === "back",
      "p-pagination__link--next": direction === "forward"
    }),
    disabled: disabled,
    onClick: onClick,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "p-icon--chevron-down"
  }, label)));
};

var _default = PaginationButton;
exports.default = _default;